// store.js
import { reactive } from 'vue'

export const store = reactive({
  token: "",
  user: {},
  roles: [],
  sucursal: [],
  // creditos:[],
  etiqueta: '',
  ready: false,

  rango: '',
  sucursalSeleccionada: '',
  asesorSeleccionado: '',
  tipoCarteraSeleccionado: '',
  estadoSeleccionado: '',


  // Solicitud Aprobacion

  aprobacion: {
    id: 0,
    validacion: false,
  },


})

